import { Injectable } from '@angular/core';
import { GatewayAPIService } from './gateway-api.service';
import { StorageService } from './storage/storageService';
import { UIHelpers } from './ui-helpers';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private api: GatewayAPIService,
    private storage: StorageService,
  ) {}

  /**
   * Checks a userid to see if they can access a particular
   * thing.
   * see: select name from auth.access_bit_names; for the full list
   */
  async checkAccess(
    accessBitIds: string | string[],
  ): Promise<Record<string, boolean>> {
    const user = this.storage.getCurrentUser();
    const accessBits = user.accessBits; 
    const allAccessNamespaces = StorageService.getAllAccessNamespaces();

    const result = {} as Record<string, boolean>;
    const populateAccessResult = (id: string): void => {
      const accessBitIndex = allAccessNamespaces.find(namespace => namespace.name === id)?.index;
      result[id] = accessBits[accessBitIndex] == '1';
    }
    if (typeof accessBitIds === 'string') {
      populateAccessResult(accessBitIds);
    } else {
      accessBitIds.map(populateAccessResult);
    }
    return Promise.resolve(result)
  }

  async getRoles(userid: string): Promise<Record<string, boolean>> {
    return this.api.apiCallSane(
      `/auth/roles/by-userid`,
      'GET',
      this.api.getDefaultHeaders(),
      { userid },
      null,
      { authenticate: false, setRoot: false },
    );
  }

  getAllAccessNamespaces(): Promise<any[]> {
    return this.api.apiCallSane(
      '/auth/all-access',
      'GET',
      this.api.getDefaultHeaders(),
      null,
      null,
      { authenticate: false, updateAuthHeader: false },
    );
  }
}
